module.exports = __webpack_public_path__ + "fonts/6FETg9Dp.woff";